import { render, staticRenderFns } from "./notification-push-dialog.vue?vue&type=template&id=47e806ce&"
import script from "./notification-push-dialog.vue?vue&type=script&lang=js&"
export * from "./notification-push-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports